var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.18182C8.18845 4.18182 5.72102 4.33954 4.15414 4.45552C3.63378 4.49404 3.23077 4.91239 3.23077 5.42337V6.00079L9.5019 9.34619C9.81167 9.51144 10.1883 9.51144 10.4981 9.34619L16.7692 6.00079V5.42337C16.7692 4.91239 16.3662 4.49404 15.8459 4.45552C14.279 4.33954 11.8115 4.18182 10 4.18182ZM16.7692 7.35274L11.0958 10.3793C10.4143 10.7428 9.58568 10.7428 8.90419 10.3793L3.23077 7.35274V13.5766C3.23077 14.0876 3.63378 14.506 4.15414 14.5445C5.72102 14.6605 8.18845 14.8182 10 14.8182C11.8115 14.8182 14.279 14.6605 15.8459 14.5445C16.3662 14.506 16.7692 14.0876 16.7692 13.5766V7.35274ZM4.05955 3.2772C5.62737 3.16115 8.13654 3 10 3C11.8635 3 14.3726 3.16115 15.9405 3.2772C17.1121 3.36393 18 4.30478 18 5.42337V13.5766C18 14.6952 17.1121 15.6361 15.9405 15.7228C14.3726 15.8388 11.8635 16 10 16C8.13654 16 5.62737 15.8388 4.05955 15.7228C2.88786 15.6361 2 14.6952 2 13.5766V5.42337C2 4.30478 2.88786 3.36393 4.05955 3.2772Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e068a6e385793fbddf9fd9f1ee680ad5.svg";
export { ForwardRef as ReactComponent };